var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5"},[_c('vx-card',{staticClass:"overflow-hidden mb-base"},[_c('div',{attrs:{"slot":"no-body"},slot:"no-body"},[_c('div',{staticClass:"p-6 flex justify-between flex-row-reverse items-center"},[_vm._v(" Cancel ")])])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }